import { DEFAULT_FILTER, STORAGE_KEY } from "@/features/organization/constants/organizationFilter";
import { TOrganizationFilterCache } from "@/features/organization/types/organizationFilter";
import { FCC } from "@/types/common";
import { Dispatch, SetStateAction, createContext, useContext, useEffect, useMemo, useState } from "react";

const loadFromStorage = (): TOrganizationFilterCache => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (!stored) return DEFAULT_FILTER;
    return { ...DEFAULT_FILTER, ...JSON.parse(stored) };
  } catch {
    return DEFAULT_FILTER;
  }
};

type TOrganizationFilterCacheContext = {
  filterCache: TOrganizationFilterCache;
  setFilterCache: Dispatch<SetStateAction<TOrganizationFilterCache>>;
};

const OrganizationFilterCacheContext = createContext<TOrganizationFilterCacheContext>({
  filterCache: DEFAULT_FILTER,
  setFilterCache: () => {},
});

export const OrganizationListFilterCacheProvider: FCC = ({ children }) => {
  const [filterCache, setFilterCache] = useState<TOrganizationFilterCache>(loadFromStorage);

  useEffect(() => {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(filterCache));
  }, [filterCache]);

  const value = useMemo(() => ({ filterCache, setFilterCache }), [filterCache]);

  return <OrganizationFilterCacheContext.Provider value={value}>{children}</OrganizationFilterCacheContext.Provider>;
};

export const useOrganizationFilterCache = () => useContext(OrganizationFilterCacheContext);
